import React, { useState } from 'react';
import { Button, Image, Modal } from 'react-bootstrap';

function ShareLinkModal({ userAppLink, webAppLink, webAppHide }) {
  const handleCloseView = () => setShowView(false);
  const [showView, setShowView] = useState(false);
  const handleShowView = () => {
    setShowView(true);
  };

  const copyToClipboard = (url) => {
    navigator.clipboard.writeText(url).then(
      () => {
        alert('Link copied to clipboard!');
      },
      (err) => {
        alert('Failed to copy text: ', err);
      }
    );
  };
  return (
    <>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowView}
      >
        <Image
          src={require('../../assets/images/UserManagement/shareIconSvg.svg')}
          alt="share"
          title="share"
          fluid
        />
      </Button>
      <Modal show={showView} onHide={handleCloseView} centered size="md">
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">Share/copy link</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <>
            <div className="d-flex justify-content-center">
              <Button
                variant="outline-dark mx-3"
                onClick={() => copyToClipboard(userAppLink)}
              >
                User App
              </Button>
              {webAppHide ? null : (
                <>
                  <Button
                    variant="outline-dark mx-3"
                    onClick={() => copyToClipboard(webAppLink)}
                  >
                    Web App
                  </Button>
                </>
              )}
            </div>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ShareLinkModal;
